import React, { useEffect, useState } from 'react';
import { getMessages, sendMessage } from '../api';
import MessageBubble from './MessageBubble';

const ChatWindow = ({ session, preloadMessages = [], onSessionCreated, selectedModel }) => {
  const [messages, setMessages] = useState(preloadMessages);
  const [input, setInput] = useState('');
  const [isSending, setIsSending] = useState(false);

  useEffect(() => {
  console.log('session:', session);
  console.log('preloadMessages:', preloadMessages);

  setMessages([]);
  if (session?.id && !session?.isNew) {
    getMessages(session.id).then(setMessages);
  }
  if (session?.id && preloadMessages?.length) {
    setMessages(preloadMessages);
  }
}, [session]);

  const handleSend = async () => {
    if (!input.trim()) return;

    setIsSending(true);
    const userMessage = {
      role: 'user',
      content: input,
      createdAt: new Date().toISOString()
    };

    // Optimistically show user message
    setMessages((prev) => [...prev, userMessage]);

    try {
      const sessionId = session?.isNew ? '' : session?.id || '';
      console.log('✅ selectedModel1:', selectedModel); // <-- Log full response object
    
      const res = await sendMessage(input, sessionId, selectedModel);
      console.log('Assistant response:', res.data); // ✅ Show response in console
      const assistantMessage = {
        role: 'assistant',
        content: res.data.content || '(no response)',
        createdAt: new Date().toISOString()
      };

      setMessages((prev) => [...prev, assistantMessage]);
      if (session?.isNew && res.data.sessionId) {
      onSessionCreated(res.data.sessionId, [
          userMessage,
          assistantMessage,
        ]);
      }
    } catch (error) {
      console.error('Send failed:', error);
    }

    setInput('');
    setIsSending(false);
  };

  return (
    <div className="col-md-8 col-lg-9 d-flex flex-column vh-100 p-3">
      {session?.isNew ? (
  <div className="d-flex justify-content-center align-items-center h-100">
    <div className="text-center">
      <h4 className="mb-3" style={{ width: '500px', margin: '0 auto' }}>What can I help with?</h4>
      <input
        type="text"
        className="form-control"
        placeholder="Ask anything"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            handleSend();
          }
        }}
        disabled={isSending}
      />
      <button className="btn btn-primary mt-2" onClick={handleSend}
        disabled={isSending}>{isSending ? 'Sending by ' + selectedModel + '...' : 'Send'}</button>
    </div>
  </div>
) : (
  <>
    <div className="flex-grow-1 overflow-auto mb-3">
      {messages.map((msg, i) => (
        <MessageBubble 
        key={i} 
        sender={msg.role} 
        text={msg.content} 
        time={msg.createdAt}
        modelAI={msg.modelAI} />
      ))}
    </div>
    <div className="d-flex">
      <input
        className="form-control flex-grow-1 me-2"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            handleSend();
          }
        }}
        placeholder="Type a message..."
        disabled={isSending}
      />
      <button className="btn btn-primary" onClick={handleSend}
        disabled={isSending}>{isSending ? 'Sending by ' + selectedModel + '...' : 'Send'}</button>
    </div>
  </>
)}
    </div>
  );
};

export default ChatWindow;
